import { tokenCanReachClaudiaConversations } from 'dashboard/helper/claudiaTokenScope';

export const conversationUIFlagsGetter = _state => conversationUuid => {
  return _state.uiFlags[conversationUuid] || { isFetching: false };
};

export const conversationRecordStatusGetter = _state => conversationUuid => {
  return _state.recordStatus[conversationUuid] || 'unknown';
};

const RECORD_STATUS_BY_HTTP_STATUS = {
  400: 'absent',
  403: 'forbidden',
};

export const recordStatusFromError = error =>
  RECORD_STATUS_BY_HTTP_STATUS[error?.response?.status] || 'error';

export const conversationStatusMutations = {
  SET_UI_FLAG(currentState, { conversationUuid, uiFlags }) {
    currentState.uiFlags = {
      ...currentState.uiFlags,
      [conversationUuid]: {
        ...(currentState.uiFlags[conversationUuid] || {}),
        ...uiFlags,
      },
    };
  },
  SET_RECORD_STATUS(currentState, { conversationUuid, status }) {
    currentState.recordStatus = {
      ...currentState.recordStatus,
      [conversationUuid]: status,
    };
  },
};

export const fetchConversationResource = async (
  { commit, rootGetters },
  { conversationUuid },
  { request, onSuccess, preserveOnError = false }
) => {
  const cognitoAccessToken = rootGetters?.getCurrentUser?.cognito_access_token;
  if (!tokenCanReachClaudiaConversations(cognitoAccessToken)) {
    if (!preserveOnError) {
      commit('SET_RECORD_STATUS', { conversationUuid, status: 'forbidden' });
    }
    return;
  }
  commit('SET_UI_FLAG', { conversationUuid, uiFlags: { isFetching: true } });
  try {
    const store = { getters: rootGetters };
    const data = await request(conversationUuid, store);
    onSuccess(commit, conversationUuid, data);
    commit('SET_RECORD_STATUS', { conversationUuid, status: 'ok' });
  } catch (error) {
    if (!preserveOnError) {
      commit('SET_RECORD_STATUS', {
        conversationUuid,
        status: recordStatusFromError(error),
      });
    }
  } finally {
    commit('SET_UI_FLAG', { conversationUuid, uiFlags: { isFetching: false } });
  }
};
